import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to get source-based report summary data
export const getSourceBasedReportSummary = async (filter = {}) => {
  console.log("🌐 [GmsSourceBasedReport] getSourceBasedReportSummary called with filter:", filter);
  try {
    const params = new URLSearchParams();
    if (filter.fromDate) params.append('fromDate', filter.fromDate);
    if (filter.toDate) params.append('toDate', filter.toDate);
    
    const url = `${BASE_URL}/api/SourceBasedReport/summary${params.toString() ? '?' + params.toString() : ''}`;
    console.log("🌐 [GmsSourceBasedReport] Making GET request to:", url);
    
    const response = await axios.get(url, {
      headers: getAuthHeader()
    });
    
    console.log("✅ [GmsSourceBasedReport] Summary data received:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ [GmsSourceBasedReport] Error fetching summary:", error);
    if (error.response) {
      console.error("❌ [GmsSourceBasedReport] Error response data:", error.response.data);
      console.error("❌ [GmsSourceBasedReport] Error response status:", error.response.status);
    }
    throw error;
  }
};

// API to export source-based customer count and revenue report to Excel
export const exportSourceBasedReportToExcel = async (filter = {}) => {
  console.log("🌐 [GmsSourceBasedReport] exportSourceBasedReportToExcel called");
  console.log("🌐 [GmsSourceBasedReport] Filter received:", filter);
  console.log("🌐 [GmsSourceBasedReport] BASE_URL:", BASE_URL);
  
  try {
    const url = `${BASE_URL}/api/SourceBasedReport/export-excel`;
    console.log("🌐 [GmsSourceBasedReport] API URL:", url);
    
    const headers = getAuthHeader();
    console.log("🌐 [GmsSourceBasedReport] Headers:", { ...headers, Authorization: headers.Authorization ? "Bearer ***" : "Missing" });
    
    console.log("🌐 [GmsSourceBasedReport] Making POST request...");
    console.log("🌐 [GmsSourceBasedReport] Request config:", {
      url,
      method: 'POST',
      data: filter,
      responseType: 'blob',
      hasAuthHeader: !!headers.Authorization
    });
    
    const response = await axios.post(url, filter, {
      headers: headers,
      responseType: 'blob'
    });
    
    console.log("✅ [GmsSourceBasedReport] API response received");
    console.log("✅ [GmsSourceBasedReport] Response status:", response.status);
    console.log("✅ [GmsSourceBasedReport] Response headers:", response.headers);
    console.log("✅ [GmsSourceBasedReport] Response data type:", typeof response.data);
    console.log("✅ [GmsSourceBasedReport] Response data size:", response.data?.size || "N/A");
    
    // Create download link
    console.log("📥 [GmsSourceBasedReport] Creating download link...");
    const url_blob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url_blob;
    const fromDateStr = filter.fromDate ? filter.fromDate.replace(/-/g, '') : 'All';
    const toDateStr = filter.toDate ? filter.toDate.replace(/-/g, '') : 'All';
    const fileName = `SourceBasedReport_${fromDateStr}_to_${toDateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`;
    link.setAttribute('download', fileName);
    console.log("📥 [GmsSourceBasedReport] File name:", fileName);
    
    document.body.appendChild(link);
    console.log("📥 [GmsSourceBasedReport] Triggering download...");
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url_blob);
    console.log("✅ [GmsSourceBasedReport] Download completed");
    
    return true;
  } catch (error) {
    console.error("❌ [GmsSourceBasedReport] Error exporting source-based report:", error);
    console.error("❌ [GmsSourceBasedReport] Error message:", error.message);
    console.error("❌ [GmsSourceBasedReport] Error response:", error.response);
    console.error("❌ [GmsSourceBasedReport] Error response data:", error.response?.data);
    console.error("❌ [GmsSourceBasedReport] Error response status:", error.response?.status);
    console.error("❌ [GmsSourceBasedReport] Error response headers:", error.response?.headers);
    console.error("❌ [GmsSourceBasedReport] Error request config:", error.config);
    throw error;
  }
};

